import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils.ts'

const avatarVariants = cva(
  'inline-flex size-6 shrink-0 items-center justify-center rounded-full text-[10px] leading-none font-bold tracking-[0.3px] text-white',
  {
    variants: {
      tone: {
        self: 'bg-blue-700',
        other: 'bg-gray-700',
        empty: 'border border-dashed border-gray-500',
      },
    },
    defaultVariants: { tone: 'other' },
  }
)

export interface AvatarProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'title'>, Required<VariantProps<typeof avatarVariants>> {
  readonly initials?: string
  readonly label: string
}

export const Avatar = React.forwardRef<HTMLSpanElement, AvatarProps>(
  ({ tone, initials, label, className, ...props }, ref) => (
    <span
      ref={ref}
      role="img"
      aria-label={label}
      title={label}
      className={cn(avatarVariants({ tone }), className)}
      {...props}>
      {tone === 'empty' ? null : initials}
    </span>
  )
)
